// Default configurations for the sma indicator
export const smaDefaultConfigurations = {
  period: 14,
  source: "adjusted_close",
  style: { color: "#D18F15" },
};

// Default configurations for the ema indicator
export const emaDefaultConfigurations = {
  period: 14,
    source: "adjusted_close",
    style: { color: "#30C10A" },
};

// List of all the indicators
export const indicatorsList = {
    "sma" :{ id: 2, label: "SMA", configurations: smaDefaultConfigurations },
    "ema" :{ id: 3, label: "EMA", configurations: emaDefaultConfigurations },
    "vwap" :{ id: 5, label: "VWAP", configurations: emaDefaultConfigurations },
    //  "supertrend" :  { id: 1, label: "supertrend", configurations: smaDefaultConfigurations },
    //  "demark" :{ id: 4, label: "demark", configurations: emaDefaultConfigurations },
};



